import { createContext } from "@singlestore/fusion/react-utils/context";

import { ProductVersionNodeForNavType, VersionToUrlType } from "types/types";

type ProductVersionContextType = {
    productVersionNode: ProductVersionNodeForNavType;
    versionToUrl?: VersionToUrlType;
};

export const [ProductVersionProvider, useProductVersion] =
    createContext<ProductVersionContextType>();
